import React from 'react';
import { block } from '../../../utils/cn';
import './ImageView.css';
const b = block('stories-image-view');
export function ImageView({ media }) {
    const type = media.type || 'image';
    return type === 'image' ? React.createElement("img", { className: b(), src: media.url, alt: "" }) : null;
}
